import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCheckbox,
    IonCol,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonRow,
    IonToggle,
} from "@ionic/react";
import Header from "../../../../../../components/Headers/Header";
import PageTitle from "../../../../../../components/PageTitle/PageTitle";
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import SelectState from "../../../../../../components/Address/SelectState";
import RequiredInputIndicator from "../../../../../../components/Forms/RequiredInputIndicator";
import DatePicker from "../../../../../../components/DatePicker/DatePicker";
import PhoneInput from "react-phone-input-2";
import PhoneNumberTypeSelect from "../../../../../../components/Contact/PhoneNumberTypeSelect";
import { Input } from "reactstrap";
import PriceField from "../../../../../../components/Forms/PriceField";
import TimePicker from "../../../../../../components/TimePicker";
import BasicTooltip from "../../../../../../components/Tooltip/BasicTooltip";
import { Address, Competition, Contact, Team, TeamMember } from "../../../../../../models";
import { PersonContext } from "../../../../../../context/PersonContext";
import { getCompetitionById, updateCompetition } from "../../../../../../utilities/competition/Competition";
import Spinner from "../../../../../../components/Spinners/Spinner";
import { RouteComponentProps, useHistory } from "react-router";
import { getTeamMembersByPersonId } from "../../../../../../utilities/teamMember/TeamMember";
import SelectTeam from "../../../../../../components/Team/SelectTeam";
import { sortTeamsByCreatedDate } from "../../../../../../utilities/team/SortTeams";
import ErrorAlert from "../../../../../../components/Errors/ErrorAlert";
import { UpdateAddressInput, UpdateCompetitionInput, UpdateContactInput } from "../../../../../../API";
import { updateAddress } from "../../../../../../utilities/address/Address";
import { updateContact } from "../../../../../../utilities/contact/Contact";
import { formatDateTimeTo24Hours } from "../../../../../../utilities/time/Time";
import { getTeamsForCurrentUser } from "../../../../../../utilities/team/TeamUtils";
import { getTeamById } from "../../../../../../utilities/team/Team";
import WarningBanner from "../../../../../../components/Banners/WarningBanner";

interface EditAELEventPageProps extends RouteComponentProps<{
    id: string;
}> {}
export interface DivisionOption {
    title: string
    val: string
    isChecked: boolean
}

let checkboxList: DivisionOption[] = [
    { title: "Open", val: "open", isChecked: true },
    { title: "Intermediate", val: "intermediate", isChecked: true },
    { title: "Novice", val: "novice", isChecked: true },
    { title: "Advanced Beginner", val: "beginner", isChecked: true },
    { title: "Beginner", val: "beginner", isChecked: true },
    { title: "Minis", val: "mini", isChecked: true },
    { title: "Adults", val: "adults", isChecked: true },
    { title: "AEL Medal", val: "medal", isChecked: true },
];

const EditAELEventPage: React.FC<EditAELEventPageProps> = ({ match }) => {
    const user = useContext(PersonContext);
    const history = useHistory();

    // Current User Membership
    const [selectedTeam, setSelectedTeam] = useState<Team | null | undefined>();
    const [competitionTeamId, setCompetitionTeamId] = useState<string | null>(null);
 
    // Competition Details
    const [competition, setCompetition] = useState<Competition | null | undefined>(null);
    const [name, setName] = useState("");
    const [competitionDate, setCompetitionDate] = useState(moment(new Date).format("YYYY-MM-DD"));
    const [entryClosingDate, setEntryClosingDate] = useState(moment(new Date).format("YYYY-MM-DD"));
    const [entryClosingTime, setEntryClosingTime] = useState<string | null | undefined>("01:00");
    const [areEntriesLimited, setAreEntriesLimited] = useState(true);
    const [entryDescription, setEntryDescription] = useState("");
    const [entryFee, setEntryFee] = useState(0);
    const [entryFeeForMedal, setEntryFeeForMedal] = useState(0);
    const [entryPaymentOptions, setEntryPaymentOptions] = useState("");
    const [address, setAddress] = useState<Address | null | undefined>(null);
    const [streetAddressLine1, setStreetAddressLine1] = useState("");
    const [streetAddressLine2, setStreetAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [provState, setProvState] = useState("");
    const [zip, setZip] = useState("");
    const [classesOffered, setClassesOffered] = useState<DivisionOption[]>(checkboxList);
    const [otherNotes, setOtherNotes] = useState("");

    // Competition Organizer
    const [organizerContact, setOrganizerContact] = useState<Contact | null | undefined>(null);
    const [organizerName, setOrganizerName] = useState("");
    const [organizerEmail, setOrganizerEmail] = useState("");
    const [organizerPhoneNumber, setOrganizerPhoneNumber] = useState("");
    const [organizerPhoneNumberType, setOrganizerPhoneNumberType] = useState("");
    
    // Competition Officials
    const [stewardName, setStewardName] = useState("");
    const [judgeName, setJudgeName] = useState("");
    const [secretaryName, setSecretaryName] = useState("");

    // Form States
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        const loadCompetition = async () => {
            const competitionId = match.params.id;
            if (!competitionId) {
                setError("Competition not found.");
                setIsInitialLoading(false);
                return;
            }

            const queryResult = await getCompetitionById(competitionId);
            if (!queryResult.isSuccess || !queryResult.result) {
                setError("Sorry, could not load the competition. Please go back and try again.");
                setIsInitialLoading(false);
                return;
            }

            const competition = queryResult.result as Competition;
            
            setCompetition(competition);
            setName(competition.name || "");
            if (competition.startDate) {
                setCompetitionDate(moment(competition.startDate).format("YYYY-MM-DD"));
            }
            if (competition.entryClosingDate) {
                setEntryClosingDate(moment(competition.entryClosingDate).format("YYYY-MM-DD"));
            }
            if (competition.entryClosingTime) {
                setEntryClosingTime(competition.entryClosingTime);
            }
            setAreEntriesLimited(competition.isEntryLimitInPlace ?? true);
            setEntryDescription(competition.entryLimitDescription || "");
            setEntryFee(competition.entryFeePerRider ?? 0);
            setEntryFeeForMedal(competition.entryFeePerRiderForMedal ?? 0);
            setEntryPaymentOptions(competition.feePaymentOptions || "");
            setOtherNotes(competition.otherNotes || "");

            const address = competition.address;
            if (address) {
                setAddress(address);
                setStreetAddressLine1(address.streetAddress1 || "");
                setStreetAddressLine2(address.streetAddress2 || "");
                setCity(address.city || "");
                setProvState(address.provState || "");
                setZip(address.zip || "");
            }

            setClassesOffered([
                { title: "Open", val: "open", isChecked: !!competition.isOpenOffered },
                { title: "Intermediate", val: "intermediate", isChecked: !!competition.isIntermediateOffered },
                { title: "Novice", val: "novice", isChecked: !!competition.isNoviceOffered },
                { title: "Advanced Beginner", val: "beginner", isChecked: !!competition.isAdvancedBeginnerOffered },
                { title: "Beginner", val: "beginner", isChecked: !!competition.isBeginnerOffered },
                { title: "Minis", val: "mini", isChecked: !!competition.isMinisOffered },
                { title: "Adults", val: "adults", isChecked: !!competition.isAdultOffered },
                { title: "AEL Medal", val: "medal", isChecked: !!competition.isAELMedalOffered },
            ]);

            setOrganizerName(competition.competitionOrganizerName || "");
            const contact = competition.contact;
            if (contact) {
                setOrganizerContact(contact);
                setOrganizerEmail(contact.workEmail || contact.personalEmail || "");
                if (contact.cell) {
                    setOrganizerPhoneNumberType("cell");
                    setOrganizerPhoneNumber(contact.cell);
                } else if (contact.home) {
                    setOrganizerPhoneNumberType("home");
                    setOrganizerPhoneNumber(contact.home);
                } else if (contact.work) {
                    setOrganizerPhoneNumberType("work");
                    setOrganizerPhoneNumber(contact.work);
                }
            }

            setJudgeName(competition.judgeName || "");
            setSecretaryName(competition.secretaryName || "");
            setStewardName(competition.StewardName || "");

            if (competition.teamId) {
                setCompetitionTeamId(competition.teamId);
                const queryResult = await getTeamById(competition.teamId);
                if (queryResult.isSuccess) {
                    const team = queryResult.result;
                    setSelectedTeam(team);
                }
            }

            setIsInitialLoading(false);
        };

        loadCompetition();
    }, [match.params.id]);

    const handleProvStateInputChange = (value: string) => {
        if (value && value !== "-") setProvState(value);
    }

    const handlePhoneNumberTypeSelectInput = (phoneNumberTypeInput: string) => {
        if (phoneNumberTypeInput && phoneNumberTypeInput !== "-"){
            setOrganizerPhoneNumberType(phoneNumberTypeInput);
        } else {
            setOrganizerPhoneNumberType("");
        }
    };

    const handleCheckboxSelect = async (index: number) => {
        const updatedItem: DivisionOption = {
            ...classesOffered[index],
            isChecked: !(!!classesOffered[index].isChecked)
        };
        const updatedList: DivisionOption[] = [
            ...checkboxList.slice(0, index),
            updatedItem,
            ...checkboxList.slice(index + 1),
        ];
        await setClassesOffered(updatedList);
    }

    const verifyForm = () => {
        if (!name) {
            setError("Please include a name for the competition.");
            return false;
        }
        if (!competitionDate) {
            setError("Please include a date for the competition.");
            return false;
        }
        if (!streetAddressLine1) {
            setError("Please include a street address for the competition.");
            return false;
        }
        if (!city) {
            setError("Please include a city for the competition.");
            return false;
        }
        if (!provState) {
            setError("Please include a state for the competition.");
            return false;
        }
        if (!zip) {
            setError("Please include a zip code for the competition.");
            return false;
        }
        if (!organizerName) {
            setError("Please include a name for the organizer of the competition.");
            return false;
        }
        if (!organizerEmail) {
            setError("Please include an email for the organizer of the competition.");
            return false;
        }
        if (!organizerPhoneNumber) {
            setError("Please include a phone number for the organizer of the competition.");
            return false;
        }
        if (!entryClosingDate) {
            setError("Please include a date for when the entries will close for the competition.");
            return false;
        }
        if (!entryFee) {
            setError("Please include an entry fee per rider for the competition.");
            return false;
        }
        if (!entryPaymentOptions) {
            setError("Please include a description for payment methods available for the competition.");
            return false;
        }
        if (areEntriesLimited && !entryDescription) {
            setError("Please include a description for payment methods available for the competition.");
            return false;
        }
        return true;
    }

    const handleUpdateCompetition = async () => {
        // Update the address
        let updatedAddress: Address | null = null;
        const addressInput: UpdateAddressInput = {
            id: address?.id || competition?.address?.id || "",
            name: name || "AEL Competition Address",
            type: "mailing",
            streetAddress1: streetAddressLine1,
            streetAddress2: streetAddressLine2 || "",
            city: city,
            provState: provState,
            zip: zip
        };
        const updateAddressResult = await updateAddress(addressInput);
        if (updateAddressResult.isSuccess) {
            updatedAddress = updateAddressResult.result;
        }

        // Update the organizer contact
        let updatedOrganizerContact: Contact | null = null;
        let contactInput: UpdateContactInput = {
            id: organizerContact?.id || "",
            name: name || "AEL Competition Organizer Contact",
            workEmail: organizerEmail
        };
        if (organizerPhoneNumberType === "cell") contactInput["cell"] = organizerPhoneNumber;
        if (organizerPhoneNumberType === "home") contactInput["home"] = organizerPhoneNumber;
        if (organizerPhoneNumberType === "work") contactInput["work"] = organizerPhoneNumber;
        const updateContactResult = await updateContact(contactInput);
        if (updateContactResult.isSuccess) {
            updatedOrganizerContact = updateContactResult.result;
        }

        const competitionInput: UpdateCompetitionInput = {
            id: competition?.id || "",
            name: name,
            startDate: competitionDate ? moment(competitionDate).format("YYYY-MM-DD") : null,
            endDate: competitionDate ? moment(competitionDate).format("YYYY-MM-DD") : null,
            organizationId: "",
            addressId: address ? address.id : "",
            teamId: selectedTeam?.id || "",
            competitionOrganizerName: organizerName,
            competitionOrganizerContactId: updatedOrganizerContact ? updatedOrganizerContact.id : "",
            judgeName: judgeName,
            secretaryName: secretaryName,
            StewardName: stewardName,
            entryFeePerRider: entryFee ? entryFee : null,
            entryFeePerRiderForMedal: entryFeeForMedal ? entryFeeForMedal : null,
            feePaymentOptions: entryPaymentOptions,
            entryClosingDate: entryClosingDate ? moment(entryClosingDate).format("YYYY-MM-DD") : null,
            entryClosingTime: entryClosingTime ? formatDateTimeTo24Hours(entryClosingDate, entryClosingTime) : null,
            isEntryLimitInPlace: areEntriesLimited,
            entryLimitDescription: entryDescription,
            otherNotes: otherNotes,
            isOpenOffered: classesOffered[0].isChecked,
            isIntermediateOffered: classesOffered[1].isChecked,
            isNoviceOffered: classesOffered[2].isChecked,
            isAdvancedBeginnerOffered: classesOffered[3].isChecked,
            isBeginnerOffered: classesOffered[4].isChecked,
            isMinisOffered: classesOffered[5].isChecked,
            isAdultOffered: classesOffered[6].isChecked,
            isAELMedalOffered: classesOffered[7].isChecked,
            status: "draft",
            lastUpdatedBy: user.id
        };
        const updateCompetitionResult = await updateCompetition(competitionInput);
        if (updateCompetitionResult.isSuccess) {
            handleNavigateToCompetitionListPage();
        } else {
            setError("An error occurred: Competition could not be updated.");
        }
    }

    const handleNavigateToCompetitionListPage = () => {
        const path = "/index/admin/competitions";
        history.replace(path);
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        const isValid = verifyForm();
        if (isValid) {
            await handleUpdateCompetition();
        }
        setIsLoading(false);
    }

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="Edit Competition" />
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeXs="12" sizeMd="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardContent>
                                {(isInitialLoading || isLoading) ?
                                    <Spinner />
                                    :
                                    <form>
                                        {error && <ErrorAlert width="12" error={error} />}
                                        {/* Basic Info Section */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Basic Info</h2>
                                            </IonCol>
                                        </IonRow>
                                        {/* Name of Competition */}
                                        <IonRow>
                                            <IonCol size="12">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ml-1">Name of Competition <RequiredInputIndicator /></IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={name}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setName(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                            <IonCol size="6">
                                                <DatePicker 
                                                    label="Date of Competition" 
                                                    isRequired
                                                    value={competitionDate}
                                                    onChange={(date: any) => setCompetitionDate(date)} 
                                                />
                                            </IonCol>
                                            <IonCol size="6" className="description text-dark">
                                                <SelectTeam 
                                                    label="Team Hosting the Competition"
                                                    selectedValue={selectedTeam?.id} 
                                                    onSelect={(team: Team) => setSelectedTeam(team)} 
                                                />
                                            </IonCol>
                                        </IonRow>

                                        {/* Competition Location Section */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Competition Location</h2>
                                                <p>Include the location that people should use in their GPS to find the competition.</p>
                                            </IonCol>
                                        </IonRow>
                                        {/* Location */}
                                        <IonRow>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked">Competition Street Address Line 1 <RequiredInputIndicator /> </IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={streetAddressLine1}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setStreetAddressLine1(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked">Competition Street Address Line 2</IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={streetAddressLine2}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setStreetAddressLine2(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeSm="12" sizeXl="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked">City <RequiredInputIndicator /> </IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={city}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setCity(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                            <IonCol sizeSm="12" sizeXl="3">
                                                <SelectState isRequired selectedValue={provState} onInputChange={handleProvStateInputChange} />
                                            </IonCol>
                                            <IonCol sizeSm="12" sizeXl="3">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked">Postal Code <RequiredInputIndicator /> </IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={zip}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setZip(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                        
                                        {/* Organizer Info */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Competition Organizer</h2>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ion-text-wrap">Competition Organizer's Name <RequiredInputIndicator /> </IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={organizerName}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setOrganizerName(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ion-text-wrap">Competition Organizer's Email <RequiredInputIndicator />  </IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={organizerEmail}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setOrganizerEmail(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <PhoneNumberTypeSelect
                                                    id="membership-app-phone-number"
                                                    isRequired={true}
                                                    selectedType={organizerPhoneNumberType}
                                                    onChange={handlePhoneNumberTypeSelectInput}
                                                />
                                            </IonCol>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonLabel position="stacked">
                                                    <p className="pl-3 description text-darker">Phone Number{" "} <RequiredInputIndicator /></p>
                                                </IonLabel>
                                                <PhoneInput
                                                    inputProps={{
                                                        name: "phone",
                                                        required: true,
                                                        autoFocus: true,
                                                        id:"membership-app-basicInfo-phone-number"
                                                    }}
                                                    placeholder="Enter phone number"
                                                    country={"us"}
                                                    enableSearch
                                                    enableAreaCodes={false}
                                                    inputStyle={{
                                                        width: "100%",
                                                        height: "auto",
                                                    }}
                                                    value={organizerPhoneNumber}
                                                    onChange={(phoneNumber: any) => {
                                                        setOrganizerPhoneNumber(phoneNumber);
                                                    }}
                                                />
                                            </IonCol>
                                        </IonRow>

                                        {/* Officials Info */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Competition Officials</h2>
                                                <p>If you do not have someone lined up yet, you can fill out the name as TBD.</p>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ion-text-wrap">Judge's Name <RequiredInputIndicator /></IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={judgeName}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setJudgeName(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ion-text-wrap">Secretary's Name <RequiredInputIndicator /></IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={secretaryName}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setSecretaryName(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeMd="6">
                                                <IonItem color="white">
                                                    <IonLabel position="stacked" className="ion-text-wrap">Steward's Name <RequiredInputIndicator /></IonLabel>
                                                    <IonInput 
                                                        type="text"
                                                        value={stewardName}
                                                        aria-required={true}
                                                        onIonChange={e => {
                                                            setStewardName(e.detail.value!)
                                                        }}
                                                    />
                                                </IonItem>
                                            </IonCol>
                                        </IonRow>

                                        {/* Classes Offered */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Competition Classes</h2>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                                <IonLabel>
                                                    <p className="pl-3 description text-dark">Select the classes that will be offered. <RequiredInputIndicator /> </p>
                                                </IonLabel>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow className="">
                                            <IonCol sizeXs="12" sizeMd="6">
                                                <IonList className="bg-white">
                                                    {classesOffered.map(({ title, val, isChecked }, i) => (
                                                        <IonItem key={i}>
                                                            <IonLabel>{title}</IonLabel>
                                                            <IonCheckbox slot="start" value={val} checked={isChecked} color="tertiary" onClick={() => handleCheckboxSelect(i)} />
                                                        </IonItem>
                                                    ))}
                                                </IonList>
                                            </IonCol>
                                        </IonRow>

                                        {/* Entry Info Section - limitations, closing date, fee, etc */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Entry Info</h2>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeSm="12" sizeXl="4" className="mt-1">
                                                <IonLabel position="stacked" className="ion-text-wrap description text-dark pl-3">Entry Fee Per Rider<RequiredInputIndicator /> </IonLabel>
                                                <PriceField value={entryFee} onChange={(feeAmount: any) => setEntryFee(feeAmount ? parseFloat(feeAmount) : 0)} />
                                            </IonCol>
                                            {(classesOffered[7] && classesOffered[7].val === "medal" && !!classesOffered[7].isChecked) && (
                                                <IonCol sizeSm="12" sizeXl="4" className="mt-1">
                                                    <IonLabel position="stacked" className="ion-text-wrap description text-dark pl-3">Medal Entry Fee Per Rider<RequiredInputIndicator /> </IonLabel>
                                                    <PriceField value={entryFeeForMedal} onChange={(feeAmount: any) => setEntryFeeForMedal(feeAmount ? parseFloat(feeAmount) : 0)} />
                                                </IonCol>
                                            )}
                                            <IonCol sizeSm="12" sizeXl="12" className="">
                                                <IonLabel>
                                                    <p className="pl-3 description text-dark">How do want to receive payment? <RequiredInputIndicator /></p>
                                                </IonLabel>
                                                <Input
                                                    rows="2"
                                                    type="textarea"
                                                    spellCheck="true"
                                                    placeholder="Explain if you want to be mailed a check (and to what address), if you want to be paid via Venmo or Zelle, etc."
                                                    value={entryPaymentOptions}
                                                    onChange={(event) => setEntryPaymentOptions(event.target.value)}
                                                />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeSm="12" sizeXl="4">
                                                <DatePicker 
                                                    label="Entry Closing Date" 
                                                    isRequired
                                                    value={entryClosingDate}
                                                    onChange={(date: any) => setEntryClosingDate(date)}
                                                />
                                            </IonCol>
                                            <IonCol sizeSm="4" sizeXl="4">
                                                <TimePicker label="Entry Closing Time" position="fixed" selectedTime={entryClosingTime} onChange={(time: string | null | undefined) => setEntryClosingTime(time)} />
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol sizeSm="12" sizeXl="4">
                                                <IonItem>
                                                    <IonLabel className="ion-text-wrap"><p className="description text-dark">Are Entries Limited?</p></IonLabel>
                                                    <IonToggle color="success" slot="end" checked={areEntriesLimited} onIonChange={e => setAreEntriesLimited(e.detail.checked)}/>
                                                </IonItem> 
                                            </IonCol>
                                            {areEntriesLimited && (
                                                <IonCol sizeSm="12" sizeXl="8">
                                                    <IonLabel>
                                                        <p className="pl-3 description text-dark">Describe how you limit entries <RequiredInputIndicator /></p>
                                                    </IonLabel>
                                                    <Input
                                                        rows="2"
                                                        type="textarea"
                                                        spellCheck="true"
                                                        placeholder="Example: entries are limited on a first come, first serve basis."
                                                        value={entryDescription}
                                                        onChange={(event) => setEntryDescription(event.target.value)}
                                                    />
                                                </IonCol>
                                            )}
                                        </IonRow>
                                    
                                        {/* Other Notes Section */}
                                        <IonRow className="mt-3 mb-0">
                                            <IonCol className="ion-text-center">
                                                <h2 className="font-weight-bold">Other</h2>
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol>
                                                <IonLabel>
                                                    <p className="pl-3 description text-dark">
                                                        Competition Notes 
                                                        <BasicTooltip label="" tip="This is a place for you to add any other information that you want included on the invitation." />
                                                    </p>
                                                </IonLabel>
                                                <Input
                                                    rows="5"
                                                    type="textarea"
                                                    spellCheck="true"
                                                    placeholder="Example: We will have a food truck from 9am-3pm. All dogs must be on leashes."
                                                    value={otherNotes}
                                                    onChange={(event) => setOtherNotes(event.target.value)}
                                                />
                                            </IonCol>
                                        </IonRow>

                                        {/* Submit Button */}
                                        <IonRow className="ion-justify-content-center">
                                            <IonCol className="text-center" sizeMd="4">
                                                <IonButton
                                                    className="mt-3"
                                                    color="tertiary"
                                                    expand="block"
                                                    onClick={handleSubmit}
                                                >
                                                    Save
                                                </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    </form>
                                }
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default EditAELEventPage;